import Search from '~/components/Search';

export const route = {
  preload: () => {},
} satisfies RouteDefinition;

export default Search;
